






































import {
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    QuestionType,
    Prop
} from "@zoovu/runner-browser-api";
import ChoiceAnswerView from './choice-answer.vue';

@Component({})
export default class FilterChoiceAnswerView extends ChoiceAnswerView {

    @Prop()
    showDisabledAnswers: boolean;

    @Prop()
    hideOptionLabels: boolean;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    get showImage(): boolean {
        return this.answer.images != null && this.answer.images[0] != null;
    }

    get filterComponentStateClasses() {
        return {
            'has-image': this.doesSomeAnswerHaveImage,
        }
    }

    get inputClasses() {
       return {
            'checkbox-indicator': this.answer.questionType === QuestionType.CHECKBOX,
            'radio-indicator': this.answer.questionType === QuestionType.RADIO,
        };
    }

    get shouldBeShown(): boolean {
        return this.answer && (!this.answer.disabled || this.showDisabledAnswers);
    }

    enterPressed() {
        (this.$refs.filterChoiceAnswerLabel as HTMLElement).click();
    }
}
